import { FC, Suspense, lazy } from "react";
import { useParams } from "react-router-dom";
import { Loading } from "../../../../../../../modules/common/loading/Loading";

const ConstellationAnalyticsView = lazy(() => import("../../../../../../../modules/constellations/views/constellation-view/subcomponents/constellation-dashboard-view/subcomponents/constellation-analytics-view/ConstellationAnalyticsView"))

export const ConstellationAnalyticsRoute: FC = () => {

    // router hooks
    const { constellation_id: constellationId } = useParams() as { constellation_id: string }

    return (
        <Suspense fallback={<Loading />}>
            <ConstellationAnalyticsView
                constellationId={constellationId}
            />
        </Suspense>
    )
}